import api from '../lib/axios';
function params(q, extra = {}) {
    return {
        from: q.from,
        to: q.to,
        ...(q.granularity ? { granularity: q.granularity } : {}),
        ...(q.compare ? { compare: 1 } : {}),
        ...extra,
    };
}
export async function getStatistics(section, q, extra) {
    const { data } = await api.get(`/api/admin/statistics/${section}`, { params: params(q, extra) });
    return data;
}
export async function getContentDetail(type, id, q) {
    const { data } = await api.get(`/api/admin/statistics/content/${type}/${id}`, { params: params(q) });
    return data;
}
export async function getPlatformStatistics(section, q) {
    const { data } = await api.get(`/api/superadmin/statistics/${section}`, {
        params: { from: q.from, to: q.to, ...(q.granularity ? { granularity: q.granularity } : {}) },
    });
    return data;
}
